import https from 'https';

export default ({ store, $axios, redirect, app: { router, context } }) => {


  /*$axios.onError(error => {
    if (error.response.status === 500) {
      redirect('/sorry')
    }
  });*/


    const agent = new https.Agent({
        rejectUnauthorized: false
    });
    $axios.onRequest(config => {
        if (process.env.VUE_APP_ENV === 'local') {
            config.httpsAgent = agent;
        }
    });

	/**
	* Add an axios interceptor to send the the app's version config to the sever.
	*/

	$axios.interceptors.request.use((config)=>{
	    // on ever request add the app's utility versions to a header,
	    // to ensure that the current session is using the latest version - if it's not we need to update the app
	    let version = store.getters["app/getApp"]
	    version.app_id = 1;
	    if (process.env.VUE_APP_ENV === 'local') {
	        config.headers['X-App-Version'] = JSON.stringify(version);
	    } else {
	        config.headers.common['X-App-Version'] = JSON.stringify(version);
	    }
	    return config;
	});

	/**
	 * Add an axios interceptor to check every response for
	 * a refresh cache header
	 */

	$axios.interceptors.response.use( (response) => {

	    // if this header is present, then the app needs to refresh it's cache and the user needs to re-login
	    if(response.headers['x-refresh-local-cache']){
	       // store.dispatch('resetStore');
	        store.commit('app/SET_APP', JSON.parse(response.headers['x-refresh-local-cache']));
	    }
	    return response;

	},  (error) => {
		if(error.response.status == 503){
	        store.commit("app/SET_DOWN_FOR_MAINTENANCE",true);
	        router.push('/maintenance');
		}

		if(error.response.status == 429){

			let number = Number(error?.response?.data?.message);
			number = isNaN(number) ? 5 : number;
	        store.commit("app/SET_RATE_LIMIT", number);

		}else{
	        store.commit("app/SET_RATE_LIMIT",false);
		}

		return Promise.reject(error);


	});
}
